import { useCallback, useLayoutEffect, useRef } from 'react';

export function useRefCallback<TArgs extends unknown[], TReturn>(
    fn: (...args: TArgs) => TReturn,
): (...args: TArgs) => TReturn {
    const ref = useRef(fn);

    useLayoutEffect(() => {
        ref.current = fn;
    });
    return useCallback((...args: TArgs) => ref.current(...args), []);
}
